var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIrishCoffee = function SvgIrishCoffee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#irish-coffee_svg__a)",
    d: "M178 222.622v8.27c0 6.687-19 12.108-43 12.108s-43-5.421-43-12.108v-8.27L135 221z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#irish-coffee_svg__b)",
    d: "M154.061 211.3c.1-.061.163-.105.163-.105v-10.726c9.089-3.092 9.05-8.93 4.187-14.885 7.2-5.977 0-12.579 0-12.579h-46.822s-7.2 6.6 0 12.579c-4.863 5.955-4.9 11.793 4.187 14.885v10.726s.066.044.163.105C101.756 213.343 92 217.592 92 222.5c0 6.9 19.252 12.5 43 12.5s43-5.6 43-12.5c0-4.913-9.756-9.162-23.939-11.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#irish-coffee_svg__c)",
    d: "M135 177c77.315 0 35.143-58.686 55.951-146.848a1.823 1.823 0 0 0-1.733-2.233C181.937 27.688 158.374 27 135 27s-46.937.688-54.218.919a1.826 1.826 0 0 0-1.733 2.233C99.857 118.314 57.685 177 135 177"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "irish-coffee_svg__a",
    x1: 92,
    x2: 98.29,
    y1: 242.758,
    y2: 173.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#027CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101,
    stopColor: "#077EB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#1686B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369,
    stopColor: "#3094C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#54A6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#81BED9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#B8DAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "irish-coffee_svg__b",
    x1: 135,
    x2: 135,
    y1: 234.318,
    y2: 13.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#027CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#067EB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    stopColor: "#1485B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.372,
    stopColor: "#2B91BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#4BA2C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#74B7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#A7D1E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#E1EFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "irish-coffee_svg__c",
    x1: 135,
    x2: 135,
    y1: 175.05,
    y2: 29.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#027CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgIrishCoffee;